export const MOCK_RESPONSE_LOGIN = {
  logoutUrl:
    'https://login-products-dev.corp.altermaind.com/realms/altermaind/protocol/openid-connect/logout',
  idpProvider: 'keycloak',
  registration: {
    authorizeUrl:
      'https://login-products-dev.corp.altermaind.com/realms/altermaind/protocol/openid-connect/registrations',
    clientId: 'slash',
    scope: 'openid profile email',
  },
  login: {
    authorizeUrl:
      'https://login-products-dev.corp.altermaind.com/realms/altermaind/protocol/openid-connect/auth',
    clientId: 'slash',
    scope: 'openid profile email',
  },
  token: {
    tokenUrl:
      'https://login-products-dev.corp.altermaind.com/realms/altermaind/protocol/openid-connect/token',
    grant_type: 'authorization_code',
    client_id: 'slash',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
  },
};
